import { SET_CURRENT_COMPANY } from 'redux/action/type'
import { DEFAULT_FINANCIAL_MONTH } from 'utils/constants/common'

interface ICompanyReduxAction {
  type: string
  data?: Partial<IGetCompanyInfo>
}

const initState: IGetCompanyInfo = {
  companyId: '',
  companyName: '',
  companyCode: '',
  financialMonth: DEFAULT_FINANCIAL_MONTH,
}

const companyReducer = (
  state: IGetCompanyInfo = initState,
  action: ICompanyReduxAction,
) => {
  switch (action.type) {
    case SET_CURRENT_COMPANY:
      return { ...state, ...action.data }
    default:
      return state
  }
}

export default companyReducer
